// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeline-fixed-width[data-v-6d8f2cfa] {\n  height: 190px;\n}\n.timeline-fixed-size[data-v-6d8f2cfa] {\n  aspect-ratio: 1.5 / 1;\n}\n.w-20[data-v-6d8f2cfa] {\n  width: 20%;\n}\n.w-0[data-v-6d8f2cfa] {\n  width: 0;\n}\n.border-dashed[data-v-6d8f2cfa] {\n  border: 1px blue dashed;\n}\n.one-to-two[data-v-6d8f2cfa] {\n  aspect-ratio: 1 / 1.6;\n}\n.two-to-one[data-v-6d8f2cfa] {\n  aspect-ratio: 2 / 1;\n}\n", ""]);
// Exports
module.exports = exports;
